/**
 * Created by Chelsea on 2018/4/9.
 */
// 配置API接口地址
function apiBase () {
  let API_BASE_URL = {}
  API_BASE_URL.url = 'http://192.168.4.216:4700/api/v1'
  API_BASE_URL.root = 'http://192.168.4.216:4700'
  // API_BASE_URL.url = 'http://127.0.0.1:4700/api/v1'
  // API_BASE_URL.root = 'http://127.0.0.1:4700'
  // API_BASE_URL.url = 'http://172.20.10.4:4700/api/v1'
  // API_BASE_URL.root = 'http://172.20.10.4:4700'
  if (document.domain.indexOf('anyknew') >= 0) {
    API_BASE_URL.url = 'https://www.anyknew.com/api/v1'
    API_BASE_URL.root = 'https://www.anyknew.com'
  }
  return API_BASE_URL
}

// 引用axios
var axios = require('axios')

function toType (obj) {
  return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase()
}

// 参数过滤函数
function filterNull (o) {
  for (var key in o) {
    if (o[key] === null) {
      delete o[key]
    }
    if (toType(o[key]) === 'string') {
      o[key] = o[key].trim()
    } else if (toType(o[key]) === 'object') {
      o[key] = filterNull(o[key])
    } else if (toType(o[key]) === 'array') {
      o[key] = filterNull(o[key])
    }
  }
  return o
}

function apiAxios (method, url, params, success, failure) {
  if (params) {
    params = filterNull(params)
  }
  var baseURL = (url.indexOf('http') > 0) ? '' : apiBase().url
  var config = {
    method: method,
    url: url,
    data: method === 'POST' || method === 'PUT' ? params : null,
    params: method === 'GET' || method === 'DELETE' ? params : null,
    baseURL: baseURL,
    withCredentials: false,
    // transformRequest: [function (data) {
    //   // Do whatever you want to transform the data
    //   // 'Content-Type': 'application/x-www-form-urlencoded' 提交data转码
    //   let ret = ''
    //   for (let it in data) {
    //     ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
    //   }
    //   return ret.substring(0, ret.length - 1)
    // }],
    headers: {
      'Authorization': localStorage.getItem('aker')
    }
  }
  axios(config)
    .then(function (res) {
      if (res.status === 200 && res.data !== null) {
        if (success) {
          success(res.data)
        }
      } else {
        if (res.response.status === 403) {
          localStorage.setItem('logined', false)
        } else {
          if (res) {
            console.log('api error, HTTP CODE: ' + res)
          }
        }
      }
    })
    // .catch(function (err) {
    //   if (err.response) {
    //     if (err.response.status === 403) {
    //       localStorage.setItem('logined', false)
    //     }
    //     console.log('api error: ' + err)
    //   } else {
    //     console.log('api error: ' + err)
    //   }
    // })
}

// 返回在vue模板中的调用接口
export default {
  get: function (url, params, success, failure) {
    return apiAxios('GET', url, params, success, failure)
  },
  post: function (url, params, success, failure) {
    return apiAxios('POST', url, params, success, failure)
  },
  put: function (url, params, success, failure) {
    return apiAxios('PUT', url, params, success, failure)
  },
  delete: function (url, params, success, failure) {
    return apiAxios('DELETE', url, params, success, failure)
  },
  apiUrls: function () {
    return apiBase()
  }
}
